import gql from 'graphql-tag';

export const DUPLICATE_VO = gql`
  mutation DuplicateVO($vendorOpportunityId: ID!) {
    result: duplicateTransaction(vendorOpportunityId: $vendorOpportunityId) {
      transactionId
      vendorOpportunityId
      dynamicsVendorOpportunityId
    }
  }
`;
